/**
 * "Billing & plans" documentation section (ADR-0074).
 *
 * How Syncanix charges: the per-workspace plan model, usage-credit (UC) metering, managing
 * your subscription and invoices, bringing your own LLM key (BYOK), and
 * the rate limits and spend caps that keep usage predictable. Prices are never
 * restated here — every commercial number links out to `/pricing`.
 */
import { BILLING_BYOK_PAGE } from './pages/billing-byok.page';
import { BILLING_LIMITS_PAGE } from './pages/billing-limits.page';
import { BILLING_OVERVIEW_PAGE } from './pages/billing-overview.page';
import { BILLING_PLANS_PAGE } from './pages/billing-plans.page';
import { BILLING_SUBSCRIPTION_PAGE } from './pages/billing-subscription.page';
import { BILLING_USAGE_PAGE } from './pages/billing-usage.page';

import type { DocSection } from './types';

export const BILLING_SECTION: DocSection = {
  id: 'billing',
  titleKey: 'docs.section.billing.title',
  pages: [
    BILLING_OVERVIEW_PAGE,
    BILLING_PLANS_PAGE,
    BILLING_USAGE_PAGE,
    BILLING_SUBSCRIPTION_PAGE,
    BILLING_BYOK_PAGE,
    BILLING_LIMITS_PAGE,
  ],
};
